
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Créer un site Internet rapidement – Conseils & Astuces (2026)",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Conscients de tous les bénéfices, vous avez enfin décidé de créer votre site Internet professionnel.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Créer un site Internet rapidement – Conseils & Astuces (2026)",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Conscients de tous les bénéfices, vous avez enfin décidé de créer votre site Internet professionnel.",
        },
      ],
    };
  },
};
